export var JourneySteps;
(function (JourneySteps) {
    JourneySteps["JourneySelection"] = "journeySelection";
    JourneySteps["Dealer"] = "dealer";
    JourneySteps["EnquiryForm"] = "enquiryForm";
    JourneySteps["Payment"] = "payment";
    JourneySteps["FinanceInsurance"] = "financeInsurance";
    JourneySteps["Finance"] = "finance";
    JourneySteps["IdentityVerification"] = "identityVerification";
    JourneySteps["Extras"] = "extras";
    JourneySteps["InsuranceCalculator"] = "InsuranceCalculator";
})(JourneySteps || (JourneySteps = {}));
//# sourceMappingURL=JourneySteps.js.map